import { withStyles } from '@material-ui/core/styles';
import styles from './ProductInfo.styles';
import ProductInfo from './ProductInfo';

export default withStyles(styles)(ProductInfo);
